import { MemberSeparationQuestionRecursive } from "pages/team-management/types";
import styles from "./DatePickerQuestion.module.css";

const { QuestionnaireCalendar } = styles;

interface DatePickerProps {
  question: MemberSeparationQuestionRecursive;
  questionId: string;
  value: string;
  onChange: (value: string) => void;
}

// Convert MM/DD/YYYY to YYYY-MM-DD for HTML date input
const formatToHtmlDate = (value: string): string => {
  if (!value) return "";

  // Check if already in YYYY-MM-DD format
  if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
    return value;
  }

  // Parse MM/DD/YYYY format
  const match = value.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
  if (!match) return "";

  const [, month, day, year] = match;
  return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
};

// Convert YYYY-MM-DD to MM/DD/YYYY for API
const formatToApiDate = (value: string): string => {
  if (!value) return "";

  // Check if already in MM/DD/YYYY format
  if (/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(value)) {
    return value;
  }

  // Parse YYYY-MM-DD format
  const match = value.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (!match) return "";

  const [, year, month, day] = match;
  return `${month}/${day}/${year}`;
};

export const DatePickerQuestion = ({
  questionId,
  value,
  onChange,
}: DatePickerProps) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const htmlDateValue = e.target.value;
    const apiDateValue = formatToApiDate(htmlDateValue);
    onChange(apiDateValue);
  };

  return (
    <input
      type="date"
      id={questionId}
      name={questionId}
      value={formatToHtmlDate(value)}
      onChange={handleChange}
      className={QuestionnaireCalendar}
    />
  );
};
